import {
    GET_OMS_STOCK_SUMMARY_REPORT_ERROR2,
    GET_OMS_STOCK_SUMMARY_REPORT_REQUEST2,
    GET_OMS_STOCK_SUMMARY_REPORT_SUCCESS2,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_OMS_STOCK_SUMMARY_REPORT_REQUEST2:
            return {
                loading: true,
            };
        case GET_OMS_STOCK_SUMMARY_REPORT_SUCCESS2:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_OMS_STOCK_SUMMARY_REPORT_ERROR2:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}